import { Link } from '@tanstack/react-router'
import { Badge } from '@/components/ui/badge'
import { useBatchCurriculum } from '@/lib/hooks/useLms'

export function AreasToImproveCard({ batchId }: { batchId: string }) {
  const { data: curriculum, isLoading } = useBatchCurriculum(batchId)

  if (isLoading || !curriculum) return null

  const incomplete = curriculum.modules
    .flatMap((m) => m.topics ?? [])
    .filter((t) => t.status !== 'completed' && (t.estimated_hours ?? 0) > 0)
    .sort((a, b) => (b.estimated_hours ?? 0) - (a.estimated_hours ?? 0))
    .slice(0, 5)

  if (incomplete.length === 0) return null

  return (
    <section className="rounded-xl border border-[#e8e4df] bg-white p-6">
      <p className="mb-4 text-[11px] font-bold uppercase tracking-wide text-[#9a9589]">
        Areas to Improve
      </p>
      <ul className="space-y-2.5" role="list">
        {incomplete.map((t) => (
          <li key={t.id} className="flex items-center gap-3">
            <Link
              to="/courses/$batchId/topics/$topicId"
              params={{ batchId, topicId: t.id }}
              className="flex-1 text-sm font-medium text-[#1a1714] hover:text-[#e8660d] transition-colors truncate"
            >
              {t.title}
            </Link>
            <Badge variant="outline" className="shrink-0 text-[10px] capitalize">
              {t.topic_type}
            </Badge>
          </li>
        ))}
      </ul>
    </section>
  )
}
